module.exports = __webpack_public_path__ + "img/thantai-banso.14124d60.png";